var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPerformanceYtd(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "936.394 163.352 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M941.394 163.352h8a5 5 0 0 1 5 5v8a5 5 0 0 1-5 5h-8a5 5 0 0 1-5-5v-8a5 5 0 0 1 5-5z",
    fill: "#548af7",
    fillRule: "evenodd",
    "data-name": "Rectangle 2919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M951.32 168.362a.516.516 0 0 0-.11-.167l-.009-.006a.515.515 0 0 0-.156-.105.498.498 0 0 0-.15-.03c-.014-.002-.027-.01-.042-.01h-4.042a.51.51 0 0 0-.506.515.51.51 0 0 0 .506.515h2.827l-4 4.094-1.522-1.983a.502.502 0 0 0-.746-.057l-3.88 3.74a.521.521 0 0 0-.02.727.502.502 0 0 0 .715.02l3.477-3.352 1.532 1.998a.502.502 0 0 0 .757.046l4.397-4.501v2.868a.51.51 0 0 0 .505.514.51.51 0 0 0 .505-.514v-4.115a.536.536 0 0 0-.039-.197Z",
    fill: "#fff",
    fillRule: "evenodd",
    "data-name": "Shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerformanceYtd);
export default __webpack_public_path__ + "static/media/performanceYTD.08bc42a1c15e0ea38f3e6f1043113bc2.svg";
export { ForwardRef as ReactComponent };